import { render, staticRenderFns } from "./OrderControllerProduct.vue?vue&type=template&id=1f0db0ea&"
import script from "./OrderControllerProduct.vue?vue&type=script&lang=js&"
export * from "./OrderControllerProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports